function getIsLLDJourneyEnabled(configuration) {
  return configuration.app?.solJourney?.lldJourney?.enabled;
}

module.exports = { getIsLLDJourneyEnabled };
